import { Box, Center, Spinner, Stack, Text, useToast } from "@chakra-ui/react";
import { getWidgetWidth } from "@govisupro/controls";
import { QRCodeSVG } from "qrcode.react";
import React, { useEffect, useState, useRef } from "react";
import { AiFillYoutube } from "react-icons/ai";
import { useWindowSize } from "react-use";
import YouTube from "react-youtube";
import { useFetch } from "../../hooks/useFetch";
import { getVideoByIdApiUrl, getYoutubePlaylistIdFromUrl, getYoutubeVideoIdFromUrl, } from "../../utils/function";
import "./index.css";
export const PlayerDevice = ({ layoutItem }) => {
    var _a, _b, _c, _d, _e;
    const youtubeData = layoutItem.widget.data;
    const [videoId, setVideoId] = useState(null);
    const [playlistId, setPlaylistId] = useState(null);
    const toast = useToast();
    const { loading, data } = useFetch(videoId ? getVideoByIdApiUrl(videoId) : null);
    const youtubeRef = useRef(null);
    const widgetRefWidth = (_a = youtubeRef === null || youtubeRef === void 0 ? void 0 : youtubeRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width;
    const { width } = useWindowSize();
    const widgetWidth = getWidgetWidth({
        layoutItemWidth: layoutItem.width,
        widgetRefWidth: widgetRefWidth
            ? widgetRefWidth / ((_b = layoutItem.scale) !== null && _b !== void 0 ? _b : 1)
            : undefined,
        windowSize: width,
        screenWidth: undefined,
        scale: (_c = layoutItem.scale) !== null && _c !== void 0 ? _c : 1,
    });
    useEffect(() => {
        if (youtubeData.videoUrl === "")
            return;
        const newVideoId = getYoutubeVideoIdFromUrl(youtubeData.videoUrl);
        const playlistId = getYoutubePlaylistIdFromUrl(youtubeData.videoUrl);
        if (!newVideoId) {
            toast({
                title: "Veuillez saisir une URL correct",
                status: "error",
                isClosable: true,
                position: "top-right",
            });
            return;
        }
        setPlaylistId(playlistId !== null && playlistId !== void 0 ? playlistId : null);
        setVideoId(newVideoId);
    }, [youtubeData.videoUrl]);
    return videoId ? (React.createElement(Stack, { direction: "row", gap: 2, width: widgetWidth },
        React.createElement(Stack, { gap: 2, flexGrow: 1, width: "85%", marginInlineStart: "0 !important" },
            youtubeData.displayTitle ? (React.createElement(Text, { fontSize: `${parseInt(youtubeData.size) / ((_d = layoutItem.scale) !== null && _d !== void 0 ? _d : 1)}px`, color: youtubeData.textColor, fontFamily: youtubeData.font, fontWeight: youtubeData.weight }, youtubeData.titleType === "default"
                ? data === null || data === void 0 ? void 0 : data.items[0].snippet.title
                : youtubeData.customTitle)) : (React.createElement(React.Fragment, null)),
            React.createElement(YouTube, { videoId: videoId, style: { width: "100%", aspectRatio: `16/9` }, iframeClassName: "youtube-video", opts: {
                    playerVars: {
                        autoplay: 1,
                        loop: 1,
                        controls: 0,
                        disablekb: 1,
                        mute: 1,
                        modestbranding: 1,
                        iv_load_policy: 3,
                        rel: 0,
                        showinfo: 0,
                        listType: "playlist",
                        list: playlistId,
                        playlist: playlistId !== null && playlistId !== void 0 ? playlistId : videoId,
                    },
                } })),
        youtubeData.displayQrCode ? (React.createElement(Stack, { width: "15%", gap: 2, marginInlineStart: "0 !important" },
            React.createElement(Text, { fontSize: `${parseInt(youtubeData.qrCodeSize) / ((_e = layoutItem.scale) !== null && _e !== void 0 ? _e : 1)}px`, color: youtubeData.qrCodeTextColor, fontFamily: youtubeData.qrCodeFont, fontWeight: youtubeData.qrCodeWeight }, "Cha\u00EEne youtube"),
            React.createElement(Box, null,
                React.createElement(QRCodeSVG, { bgColor: youtubeData.qrCodeBgColor, fgColor: youtubeData.qrCodeFgColor, level: "M", value: `https://youtube.com/channel/${data === null || data === void 0 ? void 0 : data.items[0].snippet.channelId}`, style: { width: "100%", height: "100%" } })))) : (React.createElement(React.Fragment, null)))) : (React.createElement(Center, { gap: `${widgetWidth * 0.05}px`, sx: {
            aspectRatio: "16/9",
        } }, loading ? (React.createElement(Stack, { justifyContent: "center", alignItems: "center" },
        React.createElement(Spinner, null))) : (React.createElement(React.Fragment, null,
        React.createElement(AiFillYoutube, { size: `${widgetWidth * 0.25}px`, color: "red" }),
        React.createElement(Text, { fontFamily: "Rubik", fontWeight: "bold", color: "white", fontSize: `${widgetWidth * 0.15}px` }, "Youtube")))));
};
